module.exports = __webpack_public_path__ + "static/img/active5.9b6912a0.png";